import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { AsyncStateN, Array } from '@blade/std-lib'
import { InfoMessage } from '@root/shared/ui-kit'

import { RelationFollower } from './relation-follower'

import type { FollowersFilter } from '@root/features/user/user-connections'

type Props = {
  followersFilter: FollowersFilter
}

export const RelationFollowers = ({ followersFilter }: Props) => {
  const [filterItemsState] = useAtom(followersFilter.filterItemsStateAtom)
  const refreshFilter = useAction(followersFilter.filterItemsStateAtom.refresh)

  return AsyncStateN.matchWaiting(filterItemsState, {
    Error: () => (
      <InfoContainer>
        <InfoMessage
          intent={'error'}
          variant="dt"
          onRetry={refreshFilter}
          withSeparator
        />
      </InfoContainer>
    ),
    Waiting: () => (
      <FilterResult>
        {Array.range(0, 10).map((x) => (
          <RelationFollower.Skeleton key={x} withFollowings />
        ))}
      </FilterResult>
    ),
    Success: (followings) =>
      followings.length <= 0 ? (
        <InfoContainer>
          <InfoMessage intent={'empty'} variant="dt" />
        </InfoContainer>
      ) : (
        <FilterResult>
          {followings.map((following) => (
            <RelationFollower key={following.delugeId} follower={following} />
          ))}
        </FilterResult>
      ),
  })
}

const FilterResult = styled.div`
  z-index: 0;
  display: grid;
  grid-auto-rows: max-content;
  gap: 12px;
`
const InfoContainer = styled.div`
  display: grid;
`
